export enum DashboardPeriod {
    None,
    Today,
    Yesterday,
    Last24H,
    LastWeek,
    LastMonth,
    WeekToDate,
    MonthToDate,
    Last7D,
    ThisWeek,
    Last30D,
    ThisMonth,
    Last12Months,
    Last3Months,
    LastQuarter,
    LastYear,
    NextMonth,
    NextQuarter,
    NextYear,
    QuarterToDate,
    ThisQuarter,    
    ThisYear,
    YearToDate
}